import { Box, Stack, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export default function LoadingBox({ text }) {
  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        marginTop="4rem"
      >
        <CircularProgress />

        <Typography
          variant="h6"
          sx={{ textAlign: "center", color: "#1976D2", fontWeight: "bold" }}
        >
          {text ? text : "LOADING"}
        </Typography>
      </Stack>
    </Box>
  );
}
